// External libraries
import { css } from '@emotion/core';

// Internal modules
import { DEFAULT_BORDER_COLOR } from '@/styles';

const entityMessageStyles = css`
  font-size: 11px;
  margin-top: 12px;
  padding: 12px 0;
`;

const opinionLabButtonStyles = css`
  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

const privacyAndSecurityStyles = css`
  font-size: 11px;
  margin-top: 18px;

  + p {
    border-top: 1px solid ${DEFAULT_BORDER_COLOR};
  }
`;

export {
  entityMessageStyles,
  opinionLabButtonStyles,
  privacyAndSecurityStyles,
};
